module.exports = __webpack_public_path__ + "img/about_3.0fe3bd57.png";